module.exports = __webpack_public_path__ + "img/OurATS.b1d42061.png";